import { GridLocaleText } from '@mui/x-data-grid-pro';

export const deDELocaleText: Partial<GridLocaleText> = {
    noRowsLabel: 'Keine Daten',
    noResultsOverlayLabel: 'Keine Ergebnisse gefunden.',
    toolbarDensity: 'Dichte',
    toolbarDensityLabel: 'Dichte',
    toolbarDensityCompact: 'Kompakt',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Bequem',
    toolbarColumns: 'Spalten',
    toolbarColumnsLabel: 'Spalten auswählen',
    toolbarFilters: 'Filter',
    toolbarFiltersLabel: 'Filter anzeigen',
    toolbarFiltersTooltipHide: 'Filter ausblenden',
    toolbarFiltersTooltipShow: 'Filter anzeigen',
    toolbarExport: 'Export',
    toolbarExportLabel: 'Exportieren',
    toolbarExportCSV: 'Als CSV herunterladen',
    columnMenuLabel: 'Menü',
    columnMenuShowColumns: 'Spalten anzeigen',
    columnMenuFilter: 'Filtern',
    columnMenuHideColumn: 'Spalte ausblenden',
    columnMenuUnsort: 'Sortierung entfernen',
    columnMenuSortAsc: 'Aufsteigend sortieren',
    columnMenuSortDesc: 'Absteigend sortieren',
    pinToLeft: 'Links anheften',
    pinToRight: 'Rechts anheften',
    unpin: 'Loslösen',
};
